import { render, staticRenderFns } from "./HomeScreenPromotions.vue?vue&type=template&id=112a6094&"
import script from "./HomeScreenPromotions.vue?vue&type=script&lang=js&"
export * from "./HomeScreenPromotions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports